<template>
   <div
   class="grid-item"
   :class="`grid-${size}`"
   v-scroll-reveal>
        <img v-lazy="`..${path}`" :alt="alt">
   </div>
</template>

<script>
export default {
  props: {
    'size': { type: String, default: '25' },
    'path': { type: String },
    'alt': { type: String, default: 'Project Image' }
  }

}
</script>

<style <style lang="scss" scoped>
.grid-item {
    background: transparent;
    box-shadow: none;

    img {
      width: 100%;
      box-shadow: $standard-shadow;
    }
}
</style>
